import { GuideTypesEnum } from "./guideTypes";
import { MuleVersionEnum } from "./muleVersion";

export class ServiceProperties {
  public oldGuideActive: any;
  public showGuideTab: boolean;
  public showGuideInitialDescription: boolean;
  public showGuideMandatoryRegistrationsDescription: boolean;
  public showGuideOptionalRegistrationsDescription: boolean;
  public showGuideFeesDescription: boolean;
  public showGuideRequiredDocumentsDescription: boolean = false;
  public showDataFirstInPartBRoleForm: boolean = false;
  public requiredDocumentsOpenByDefault: boolean;
  public showGuideConditionsDescription: boolean;
  public showOnlyGuideQuestions: boolean;
  public defaultPrintTemplate: string;
  public contactAddress: string;
  public contactPhone: string;
  public contactTitle: string;
  public contactUrl: string;
  public showOnlyRegistrationFields: boolean = false;
  public showOnlyRegistrationFieldsPartB: boolean = true;
  public cacheEnabled: boolean = false;
  public showPageName: boolean;
  public useFilePreviewComponent: boolean;
  public showApplicationHistory: boolean;
  public showPrintButtonOnGuide: boolean;
  public activateShoppingCartOnEventshoppingCartActiveClick: boolean;
  public showPrintButtonInPartB: boolean = false;
  public partBprintAction: string;
  public customTheme: string = "modern-theme";
  public shoppingCartActive: boolean;
  public activateShoppingCartOnEvent: boolean;
  public hideCostIfMissing: boolean;
  public requirementsFilePattern: string = ".pdf,.jpg,.jpeg,.png,.bmp,.doc,.docx,.odt,.rtf,.pages";
  public validateRoleFields: boolean;
  public domain: string;
  public blocksCollapsibleInBpa: boolean = true;
  public showDecimalsForCosts: boolean;
  public enableDuplicatedKeysVerification: boolean = true;
  public useBPAPartBSaveButtons: boolean;
  public guideType: GuideTypesEnum = GuideTypesEnum[2];
  public muleVersion: MuleVersionEnum = MuleVersionEnum[0];
  public partBReadOnlyForm: string = "TABLE_STYLE";
}
